export default {"src":"/_next/static/media/ic_verified_badge.ce42610f.svg","height":14,"width":14};